import { Component, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { LandingPageService } from '../../services/landing.service';
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faEye, faEllipsisVertical, faEdit, faTrash, faPlus } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-landing-list',
  standalone: true,
  imports: [CommonModule, RouterLink, NavbarComponent, FooterComponent, FontAwesomeModule],
  templateUrl: './landing-list.component.html',
  styleUrl: './landing-list.component.css'
})
export class LandingListComponent implements OnInit {

  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly landingService = inject(LandingPageService);

  //Iconos
  readonly faEye = faEye;
  readonly faEllipsisVertical = faEllipsisVertical;
  readonly faEdit = faEdit;
  readonly faTrash = faTrash;
  readonly faPlus = faPlus;

  // Signals
  readonly currentOrgId = signal<string>('');
  readonly pages = signal<any[]>([]);
  readonly isLoading = signal<boolean>(false);
  readonly errorMsg = signal<string>('');

  ngOnInit(): void {
    const orgId = this.route.snapshot.params['id'];
    this.currentOrgId.set(orgId);

    console.log('📋 Cargando landing pages para:', orgId);
    this.loadPages();
  }

  loadPages(): void {
    this.isLoading.set(true);
    this.errorMsg.set('');

    // GET /landing-pages?org_id={orgId}
    this.landingService.getLandingPagesByOrg(this.currentOrgId()).subscribe({
      next: (response) => {
        console.log('✅ Respuesta del servidor:', response);

        // Ajusta según la estructura de tu respuesta
        // Puede ser response.pages o response.items o response directamente
        const pages = response.pages || response.items || response || [];

        console.log('📸 Primera página completa:', pages[0]);
      console.log('📸 Campos disponibles:', Object.keys(pages[0] || {}));

        this.pages.set(pages);
        console.log('✅ Páginas cargadas:', pages);
        this.isLoading.set(false);
      },
      error: (error) => {
        console.error('❌ Error cargando páginas:', error);
        this.errorMsg.set('Error al cargar las landing pages');
        this.isLoading.set(false);
      }
    });
  }

  getPageUrl(slug: string): string {
    const url = `${window.location.origin}/sitios/${this.currentOrgId()}/${slug}`;

    console.log('🔗 URL construida:', url); // 👈 Agregar este log

    return url;
  }

  crearNueva(): void {
    this.router.navigate(['/admin-hotel/alojamientos', this.currentOrgId(), 'sitios', 'nuevo']);
  }

  editarLanding(pageId: string, slug: string): void {
    // Navegar al editor pasando pageId y slug
    this.router.navigate(
      ['/admin-hotel/alojamientos', this.currentOrgId(), 'sitios', 'editar'],
      { queryParams: { pageId, slug } }
    );
  }

  verLanding(slug: string): void {
    const url = this.getPageUrl(slug);
    console.log('👁️ Intentando abrir:', url); // 👈 Agregar este log
    window.open(url, '_blank');
  }

  async deletePage(pageId: string, slug: string): Promise<void> {
    if (!confirm(`¿Seguro que deseas eliminar la página "${slug}"?\n\nEsta acción no se puede deshacer.`)) {
      return;
    }

    console.log('🗑️ Intentando eliminar:', {
      pageId,
      slug,
      orgId: this.currentOrgId()
    });

    this.isLoading.set(true);

    // 👇 Pasar pageId Y orgId
    this.landingService.deleteLandingPage(pageId, this.currentOrgId()).subscribe({
      next: (response) => {
        console.log('✅ Respuesta de eliminación:', response);
        alert('✅ Página eliminada exitosamente');
        this.loadPages(); // Recargar lista
      },
      error: (error) => {
        console.error('❌ Error eliminando página:', error);
        console.error('❌ Status:', error.status);
        console.error('❌ Body:', error.error);

        const errorMsg = error.error?.error || error.message || 'Error desconocido';
        alert(`❌ Error al eliminar: ${errorMsg}`);

        this.isLoading.set(false);
      }
    });
  }
}
